import { Component } from '@angular/core';

import { DynamicFormControlBaseComponent } from './dynamic-form-control.base-component';

@Component({
  template: '',
  selector: 'lh-dynamic-form-input-base',
  standalone: false,
})
export abstract class DynamicFormInputBaseComponent extends DynamicFormControlBaseComponent {}
